<template lang="pug">
a.play-btn.video-btn(v-if='videoUrl' @click="playVideo()" data-toggle='modal', :data-src='videoUrl', data-target='#modal')
    img(:alt='imgPlayAlt' :class='isWhite ? "white" : ""')
</template>

<script>
import MODAL from '@/constants/modal-types'

export default {
    props: {
        videoUrl: { type: String, required: true },
        isWhite: { type: Boolean, default: false }
    },
    data() {
      return  {
          imgPlayAlt: 'Ver video',
          modal: {
              url: this.videoUrl,
              type: MODAL.VIDEO
          }
      }  
    },
    methods: {
        playVideo() {
            this.$bus.$emit('show', this.modal)            
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/PlayButton.vue